
import { AMMUNITION_STOCK_METADATA } from './ammunition-stock.metadata';
import { AmmunitionStockBase } from './ammunition-stock.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface AmmunitionStock extends AmmunitionStockBase {
}

export interface AmmunitionStockTransient { }

export class AmmunitionStock extends CrudEntity<AmmunitionStock, number, AmmunitionStockTransient> implements AmmunitionStockTransient {
  constructor(source?: Partial<AmmunitionStock>, options?: CrudEntityConstructionOptions<AmmunitionStock, number, AmmunitionStockTransient>) {
    super(AMMUNITION_STOCK_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }

  setHasStocktake(value: boolean) {
    this.entity['hasStocktake' as any] = value;
  }
}





